module.exports = __webpack_public_path__ + "img/quotation-marks.6b76fbcc.svg";